// Voice family for AI-generated copy, chosen per piece in the Lead Generation
// and MyBrand wizards. Mirrors ContentAudience in the api: one account produces
// both families, and Residential is the default everywhere, so omitting the
// field leaves generation exactly as it was.
//
// The user-facing copy and the display helpers built on this live in
// utils/contentAudience.
export enum ContentAudience {
    Residential = "Residential",
    Commercial = "Commercial",
}

export const CONTENT_AUDIENCES: readonly ContentAudience[] = [
    ContentAudience.Residential,
    ContentAudience.Commercial,
];
